import { apiWithAuth } from "../authApi";
import {
  Deposit,
  DepositPayload,
  Deposits,
  MinDeposit,
} from "@/modules/user/types/wallet";

export const getDeposit = async (): Promise<Deposit | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/deposit");

    const answer = response.data as Deposit;

    return answer;
  } catch (error) {
    return undefined;
  }
};

export const getMinDeposit = async (): Promise<MinDeposit | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/deposit/minimum");

    const answer = response.data as MinDeposit;

    return answer;
  } catch (error) {
    return undefined;
  }
};

export const getDepositPayload = async (
  tonAmount: string
): Promise<DepositPayload | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/deposit/payload", {
      params: {
        tonAmount,
      },
    });

    const answer = response.data as DepositPayload;

    return answer;
  } catch (error) {
    return undefined;
  }
};

export const getDepositTokenPayload = async (
  tokenAmount: string
): Promise<DepositPayload | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/deposit/jetton/payload", {
      params: {
        tokenAmount,
      },
    });

    const answer = response.data as DepositPayload;

    return answer;
  } catch (error) {
    return undefined;
  }
};

export const getWattsTapTokenPayload = async (
  tokenAmount: string
): Promise<DepositPayload | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/wattstap/jetton/payload", {
      params: {
        tokenAmount,
      },
    });

    const answer = response.data as DepositPayload;

    return answer;
  } catch (error) {
    return undefined;
  }
};

export const getDeposits = async (): Promise<Deposits | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/deposits");

    const answer = response.data as Deposits;

    return answer;
  } catch (error) {
    return undefined;
  }
};
